import { render, staticRenderFns } from "./NewsListItem.vue?vue&type=template&id=3c297fe6&"
import script from "./NewsListItem.vue?vue&type=script&lang=js&"
export * from "./NewsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports